import React, { useEffect, useState } from 'react'
import { Checkbox } from 'antd'
import type { CheckboxValueType } from 'antd/lib/checkbox/Group'
import { SearchCheckboxWrapper } from '@/modules/products/components/SearchCheckbox'
import { FilterItemType, FilterMap } from '@/modules/products/viewModels/ProductListViewModel'

const CheckboxGroup = Checkbox.Group

export interface SearchCheckboxProps {
	idx: number
	// checkboxList: string[]
	checkboxList: FilterItemType[]
	filterItems: FilterMap
	updateFilterItem: (filter: string, item: FilterItemType[]) => void
	deleteItem: any
	// resetFilter: boolean
}

export const SearchCheckboxModal: React.FC<SearchCheckboxProps> = ({
	idx,
	checkboxList,
	filterItems,
	updateFilterItem,
	deleteItem,
	// resetFilter,
}) => {
	//체크박스에 들어갈 옵션
	// const plainOptions = checkboxList.list

	const [checkedList, setCheckedList] = useState<CheckboxValueType[]>([])
	const onChange = (list: CheckboxValueType[]) => {
		setCheckedList(list)
	}

	// 리셋 없음
	/*
	useEffect(() => {
		if (resetFilter) {
			setCheckedList([])
		}
	}, [resetFilter])
	*/

	/*
	useEffect(() => {
		const deleteArr = checkedList.filter((item) => item !== deleteItem.name)
		if (deleteArr.length !== checkedList.length) {
			setCheckedList(deleteArr)
		}
	}, [deleteItem])
	*/

	// useEffect(() => {
	// 	let newArr = []
	// 	checkedList.map((item) => {
	// 		newArr.push({ idx: idx, name: item.toString() })
	// 	})
	//
	// 	let arraySum = filterItems.concat(newArr)
	//
	// 	let nArr = arraySum.filter((item, i) => {
	// 		return (
	// 			arraySum.findIndex((item2, j) => {
	// 				return item.value === item2.value
	// 			}) === i
	// 		)
	// 	})
	//
	// 	updateFilterItem('unknown', nArr)
	// }, [checkedList])

	useEffect(() => {
		// 체크 해제했을 때 필터에서도 삭제
		// !! 여기서는 적용 버튼 눌렀을 때 업데이트 !!
		/*
		checkboxList.map((item) => {
			if (checkedList.indexOf(item) === -1) {
				const testArr = [...filterItems]
				testArr.map((filterItem) => {
					if (filterItem.name === item) {
						testArr.splice(testArr.indexOf(filterItem), 1)
					}
				})

				if (filterItems.length !== testArr.length) {
					runInAction(() => {
						updateFilterItem(testArr)
					})
				}
			}
		})
		*/
	}, [filterItems])

	const [options, setOptions] = useState(checkboxList.slice(0, 3))

	return (
		<SearchCheckboxWrapper>
			{/*<CheckboxGroup options={options} value={checkedList} onChange={onChange} />*/}
		</SearchCheckboxWrapper>
	)
}
